import React, { useEffect, useRef, useState } from 'react'
import styled from 'styled-components'
import AppUserWithBooksResponse from '../AppUserWithBooksResponse'
import ColSpacer from '../../../common/styles/ColSpacer'
import Spacer from '../../../common/Spacer'
import BooksitoutImages from '../../../images/BooksitoutImages'
import breakpoints from "../../../config/Breakpoints";
import RowSpacer from "../../../common/styles/RowSpacer";

interface Props {
    appUserWithBooks: AppUserWithBooksResponse
}

const ProfileListItem: React.FC<Props> = ({appUserWithBooks}) => {
    const bookListRef = useRef<HTMLDivElement>(null)
    const [isOverflowing, setIsOverflowing] = useState(false)

    useEffect(() => {
        const el = bookListRef.current
        if (!el) return

        const check = () => setIsOverflowing(el.scrollWidth > el.clientWidth)
        check()

        const observer = new ResizeObserver(check)
        observer.observe(el)
        return () => observer.disconnect()
    }, [appUserWithBooks.books])

    return (
        <a href={`/users/${appUserWithBooks.user.urlName}`}>
            <ProfileContainer>
                <div className={'d-flex flex-row align-items-center'}>
                    {appUserWithBooks.user.profileImageUrl != null && appUserWithBooks.user.profileImageUrl !== '' ?
                        <ProfileImage src={appUserWithBooks.user.profileImageUrl} alt={appUserWithBooks.user.name}
                                      onError={(e) => e.target.src = BooksitoutImages.Placeholder.user}/> :
                        <ProfileImage src={BooksitoutImages.Placeholder.user} alt={appUserWithBooks.user.name}/>}

                    <ColSpacer size={15}/>

                    <ProfileInfoContainer>
                        <ProfileName>{appUserWithBooks.user.name == '' ? '-' : appUserWithBooks.user.name}</ProfileName>

                        <RowSpacer size={3}/>

                        <ProfileDate>
                            {appUserWithBooks.user.registeredDate[0]}년 {appUserWithBooks.user.registeredDate[1]}월 {appUserWithBooks.user.registeredDate[2]}일
                        </ProfileDate>
                    </ProfileInfoContainer>
                </div>

                <Spacer/>

                <BookListWrapper>
                    <BookListContainer ref={bookListRef}>
                        {appUserWithBooks.books.map(book => (
                            <BookCover
                                src={book.cover && book.cover.trim() !== '' ? book.cover : BooksitoutImages.Placeholder.bookCover}
                                alt={book.title}/>
                        ))}
                    </BookListContainer>
                    {isOverflowing && <BookListFade />}
                </BookListWrapper>
            </ProfileContainer>
        </a>
    )
}

const ProfileContainer = styled.div`
    display: flex;

    @media (max-width: ${breakpoints.md}) {
        flex-direction: column;
    }
`

const ProfileImage = styled.img.attrs({
    className: 'rounded',
})`
    width: 50px;
    height: 50px;
`

const ProfileInfoContainer = styled.div`
    max-width: 200px;
`

const ProfileName = styled.h1.attrs({
    className: 'clamp-1-line',
})`
    font-size: 1.5rem;
    font-weight: bold;
    color: var(--text-color);
    margin: 0;
`

const ProfileDate = styled.h1`
    font-size: 1rem;
    color: var(--sub-text-color);
    margin: 0;
`

const BookListWrapper = styled.div`
    position: relative;
    max-width: 50%;

    @media (max-width: ${breakpoints.md}) {
        max-width: 100%;
    }
`

const BookListContainer = styled.div`
    padding-left: 10px;
    color: var(--text-color);
    overflow: hidden;
    display: flex;
    flex-wrap: nowrap;
    white-space: nowrap;

    @media (max-width: ${breakpoints.md}) {
        padding-left: 0;
        padding-top: 10px;
    }
`

const BookListFade = styled.div`
    position: absolute;
    top: 0;
    right: 0;
    width: 60px;
    height: 100%;
    background: linear-gradient(to right, transparent, var(--card-card-bg-color));
    pointer-events: none;
`

const BookCover = styled.img.attrs({
    className: 'rounded',
})`
    height: 60px;
    padding-left: 3px;
    padding-right: 3px;
`

export default ProfileListItem
